import TourneyDetailsHeader from '@/src/components/TourneyDetails/TourneyDetailsHeader';
import React, { useState, useEffect } from 'react';
import TourneyDetailsEntries from '@/src/components/TourneyDetails/TourneyDetailsEntries';
import TourneyDetailsPrizes from '@/src/components/TourneyDetails/TourneyDetailsPrizes';
import TourneyDetailsRules from '@/src/components/TourneyDetails/TourneyDetailsRules';
import TourneyDetailsBlindStructure from '@/src/components/TourneyDetails/TourneyDetailsBlindStructure';
import TourneyDetailsTable from '@/src/components/TourneyDetails/TourneyDetailsTable';
import TourneyDetailsRebuyInfo from '@/src/components/TourneyDetails/TourneyDetailsRebuyInfo';
import TourneyDetailsFlights from '@/src/components/TourneyDetails/TourneyDetailsFlights';
import TourneyDetailsPrizeStructure from '@/src/components/TourneyDetails/TourneyDetailsPrizeStructure';
import TourneyDetailsBountyInfo from '@/src/components/TourneyDetails/TourneyDetailsBountyInfo';
import TourneyDetailsOverview from '@/src/components/TourneyDetails/TourneyDetailsOverview';

import ChevronRight from '@/src/assets/ChevronRight';
import TreeNodeIcon from '@/src/assets/TreeNodeIcon';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger
} from '../../components/ui/drawer';
import CloseIcon from '@/src/assets/CloseIcon';
import SeriesTicketIcon from '@/src/assets/SeriesTicketIcon';
import useMasterTourneyDefinitionsIds from '@/src/hooks/data/useMasterTourneyDefinitionsIds';
import useGetSingleTourneyDefinitionById from '@/src/hooks/data/useGetSingleTourneyDefinitionById';
import useTourneyDetails from '@/src/hooks/utils/useTourneyDetails';
import { useNavigate, useParams } from 'react-router';
import useTourneyLobby from '@/src/hooks/utils/useTourneyLobby';
import { format, formatDistance } from 'date-fns';
import gameAssets from '@themed-assets';
import ChainIcon from '@/src/assets/ChainIcon';
import useTourneyApiService from '@/src/hooks/utils/useTourneyApiService';
import Loading from '@/src/assets/Loading';
import useGetAllTourneyTickets from '@/src/hooks/data/useGetAllTourneyTickets';
import {
  TOURNEY_TYPES,
  TOURNEY_REGISTRATION_STARTED,
  TOURNEY_ANNOUNCED,
  TOURNEY_STATUS_COMPLETED,
  TOURNEY_PLAYER_STATUS_RE_ENTRY,
  TOURNEY_REGISTERED,
  TOURNEY_STATUS_LIVE,
  TOURNEY_OFFLINE_PAUSED,
  TOURNEY_STATUS_CANCELLED,
  TOURNEY_STATUS_MISSED,
  TOURNEY_STATUS_WON,
  TOURNEY_REGISTRATION_ENDED
} from '@/Poker/data/Constants';
import useLobby from '@/src/hooks/data/useLobby';
import useTourneyActiveGames from '@/src/hooks/data/useTourneyActiveGames';
import usePlatformCommunication from '@/src/hooks/utils/usePlatformCommunication';
import {
  PSEUDO_EXPIRED_PLAYER,
  PSEUDO_LOCKED_PLAYER
} from '@/Poker/data/Constants';
import { toast } from 'sonner';
import useGetTourneyRegDeRegLoadingState from '@/src/hooks/data/useGetTourneyRegDeRegLoadingState';
import { showToast } from '@/Poker/utils/toastUtils';
import { TOAST_ERROR } from '@/Poker/data/Constants';
import TourneyDetailsTargetTourney from '@/src/components/TourneyDetails/TourneyDetailsTargetTourney';
import TourneyDetailsSimilarFlightsBadge from '@/src/components/TourneyDetails/TourneyDetailsSimilarFlightsBadge';
import TourneyDetailsTabBar from '@/src/components/TourneyDetails/TourneyDetailsTabBar';
import CountdownTimer, {
  RunningSinceTimer
} from '@/src/components/Common/CountdownTimer';
import useScrollToTop from '@/src/hooks/utils/useScrollToTop';
import ScrollToTopButton from '@/src/components/Common/ScrollToTopButton';
import { Button } from '@/src/components/ui/button';

const TABS_CONFIG = [
  {
    lable: 'Overview',
    key: 'overview',
    visible: [
      'GTD',
      'Free Roll',
      'Satellite',
      'Sit And Go',
      'Flight_Parent',
      'Flight_Child',
      'Bounty'
    ]
  },
  {
    lable: 'Entries',
    key: 'entries',
    visible: [
      'GTD',
      'Free Roll',
      'Satellite',
      'Flight_Parent',
      'Flight_Child',
      'Bounty'
    ]
  },
  {
    lable: 'Prizes',
    key: 'prizes',
    visible: ['GTD', 'Free Roll', 'Satellite', 'Flight_Parent']
  },
  {
    lable: 'Tables',
    key: 'tables',
    visible: [
      'GTD',
      'Free Roll',
      'Satellite',
      'Flight_Parent',
      'Flight_Child',
      'Bounty'
    ]
  },
  {
    lable: 'Rules',
    key: 'rules',
    visible: [
      'GTD',
      'Free Roll',
      'Satellite',
      'Flight_Parent',
      'Flight_Child',
      'Bounty'
    ]
  },
  {
    lable: 'Blind Structure',
    key: 'blindStructure',
    visible: [
      'GTD',
      'Free Roll',
      'Satellite',
      'Sit And Go',
      'Flight_Parent',
      'Flight_Child',
      'Bounty'
    ]
  },
  {
    lable: 'Prize Structure',
    key: 'prizeStructure',
    visible: ['GTD', 'Free Roll', 'Satellite', 'Flight_Parent', 'Bounty']
  },
  {
    lable: 'Rebuy Info',
    key: 'rebuyInfo',
    visible: ['GTD', 'Free Roll', 'Satellite', 'Flight_Child', 'Bounty']
  },
  {
    lable: 'Flights',
    key: 'flights',
    visible: ['Flight_Parent', 'Flight_Child']
  },
  {
    lable: 'Target Tourney',
    key: 'targetTourney',
    visible: ['Satellite', 'Flight_Child', 'Bounty']
  },
  {
    lable: 'Bounty Info',
    key: 'bountyInfo',
    visible: ['Bounty']
  }
];

function TourneyDetails(props) {
  const navigate = useNavigate();
  const [TABS, setTABS] = useState(TABS_CONFIG);
  const [activeTab, setActiveTab] = useState('overview');
  const [registerTourneyLoading, setRegisterTourneyLoading] = useState(false);
  const { tourneyId } = useParams();
  const [showReEntryModal, setShowReEntryModal] = useState(false);

  const { addCashNavigation } = usePlatformCommunication();

  const tourneyApi = useTourneyApiService();
  const selectedTourneyDetails =
    useGetSingleTourneyDefinitionById(tourneyId) || {};
  const tourneyDetails = useTourneyDetails();
  const tournetTicketIds = useGetAllTourneyTickets();
  const user = useLobby();
  const { displayName } = user;

  const tourneyActiveGames = useTourneyActiveGames(tourneyId);
  console.log(
    'selectedTourneyDetailsselectedTourneyDetails: ',
    selectedTourneyDetails
  );

  const {
    tourneyStatus,
    tourneyStartTime,
    lateRegEnded,
    lateRegEndTime,
    inTheMoney
  } = selectedTourneyDetails;

  const tourneyRegDeRegLoadingState = useGetTourneyRegDeRegLoadingState();
  console.log(
    selectedTourneyDetails?.payoutType,
    'selectedTourneyDetails?.payoutType'
  );

  useEffect(() => {
    // to get the running tables list
    tourneyDetails?.fetchTourneyTables(selectedTourneyDetails?.tourneyId);
    if (selectedTourneyDetails?.tournamentType) {
      // let tabListToShow = TABS.filter((item) =>
      let tabListToShow = TABS_CONFIG.filter((item) =>
        item.visible.includes(selectedTourneyDetails?.tournamentType)
      );

      if (selectedTourneyDetails?.tourneyStatus !== TOURNEY_STATUS_LIVE) {
        console.log(
          'bbbbb1',
          selectedTourneyDetails?.tournamentType,
          tabListToShow,
          selectedTourneyDetails?.payoutType
        );
        tabListToShow = tabListToShow?.filter((item) => item.key !== 'tables');
      }
      if (selectedTourneyDetails?.tourneyStatus === TOURNEY_STATUS_LIVE) {
        console.log(
          'bbbbb2',
          selectedTourneyDetails?.tournamentType,
          tabListToShow,
          selectedTourneyDetails?.payoutType
        );

        tabListToShow = tabListToShow.map((item) =>
          item.key === 'entries' ? { ...item, lable: 'Rank' } : item
        );
      }
      if (
        selectedTourneyDetails?.reEntryType === 'None' ||
        selectedTourneyDetails?.reEntryType === 'ReEntry'
      ) {
        console.log(
          'bbbbb3',
          selectedTourneyDetails?.tournamentType,
          tabListToShow,
          selectedTourneyDetails?.payoutType
        );

        tabListToShow = tabListToShow?.filter(
          (item) => item.key !== 'rebuyInfo'
        );
      }
      if (selectedTourneyDetails?.payoutType === 'Fixed') {
        console.log(
          tabListToShow,
          'tabListToShow',
          selectedTourneyDetails?.payoutType,
          selectedTourneyDetails?.tournamentType
        );
        tabListToShow = tabListToShow?.filter(
          (item) => item.key !== 'prizeStructure'
        );
      }
      setTABS(tabListToShow);
    }
  }, [
    selectedTourneyDetails?.tourneyId,
    selectedTourneyDetails?.tournamentType,
    selectedTourneyDetails?.tourneyStatus
  ]);

  useEffect(() => {
    if (tourneyId) {
      setActiveTab('overview');
    }
  }, [tourneyId]);

  const handleNotification = () => {
    tourneyApi?.remindMeTourney(selectedTourneyDetails?.tourneyId);
  };

  const handleRegisterTourney = () => {
    if (
      user?.player?.playerStatus === PSEUDO_LOCKED_PLAYER ||
      user?.player?.playerStatus === PSEUDO_EXPIRED_PLAYER
    ) {
      showToast(TOAST_ERROR, 'Player is restricted');
      return;
    } else {
      setRegisterTourneyLoading(true);
      console.log('handleRegisterTourney clicked ');
      tourneyApi?.registerTourney(selectedTourneyDetails?.tourneyId);
    }
  };

  const handleDeregisterTourney = () => {
    tourneyApi?.deRegisterTourney(selectedTourneyDetails?.tourneyId);
  };

  const handleReEntryTourney = () => {
    tourneyApi?.ReRegisterTourney(selectedTourneyDetails?.tourneyId);
  };

  const getTourneyBuyIn = () => {
    const { buyIn, tourneyRake, bountyTourney, bountyBuyIn } =
      selectedTourneyDetails;

    if (bountyTourney) {
      return buyIn + tourneyRake + bountyBuyIn;
    } else {
      return buyIn + tourneyRake;
    }
  };
  const checkUserHasTicket = (tourneyId) => {
    // return tournetTicketIds.includes(tourneyId);
    return tournetTicketIds?.filter((o) => o.tourneyId == tourneyId).length;
  };

  // const getTourneyStatusText = (currentTourneyStatus) => {
  //   switch (currentTourneyStatus) {
  //     case TOURNEY_STATUS_CANCELLED:
  //       return (
  //         <div className="w-full text-xs text-primary text-center font-medium">
  //           CANCELLED
  //         </div>
  //       );
  //     case TOURNEY_OFFLINE_PAUSED:
  //       return (
  //         <div className="w-full text-xs text-primary text-center font-medium">
  //           PAUSED
  //         </div>
  //       );
  //     case TOURNEY_STATUS_MISSED:
  //       return (
  //         <div className="w-full text-xs text-primary text-center font-medium">
  //           MISSED
  //         </div>
  //       );
  //     case TOURNEY_STATUS_WON:
  //       if (
  //         selectedTourneyDetails?.isFlightTourney &&
  //         !selectedTourneyDetails?.isFlightParentTourney
  //       ) {
  //         return (
  //           <div className="w-full text-xs text-primary text-center font-medium">
  //             QUALIFIED
  //           </div>
  //         );
  //       }

  //       return (
  //         <div className="w-full text-xs text-primary text-center font-medium">
  //           YOU WON
  //         </div>
  //       );
  //     case TOURNEY_STATUS_COMPLETED:
  //       return (
  //         <div className="w-full text-xs text-primary text-center font-medium">
  //           COMPLETED
  //         </div>
  //       );
  //   }
  // };

  const [remainingStartTime, setRemainingStartTime] = useState(-1);
  const currentLobbyTime = new Date();

  const getTourneyTimerLabelAndColor = (status) => {
    if (status === TOURNEY_STATUS_LIVE && remainingStartTime >= 0) {
      if (!lateRegEnded && lateRegEndTime > 0 && !inTheMoney) {
        return { label: 'Late Reg.', color: 'text-late' };
      }
      return { label: 'Running Since', color: 'text-success' };
    }

    if (
      status === TOURNEY_ANNOUNCED ||
      status === TOURNEY_REGISTRATION_STARTED ||
      status === TOURNEY_REGISTRATION_ENDED
    ) {
      return { label: 'Starts in', color: '' };
    }

    return { label: '', color: '' };
  };
  const { scrollContainerRef, showScrollToTop, scrollToTop } =
    useScrollToTop(600);
  useEffect(() => {
    if (tourneyStatus === TOURNEY_STATUS_LIVE) {
      handleTourneyStatusLiveTimer();
    } else {
      handleTourneyRemainingTimeToStartTimer();
    }
    return () => {};
  }, [tourneyStatus]);

  const handleTourneyStatusLiveTimer = () => {
    const difference = currentLobbyTime - new Date(tourneyStartTime * 1000);
    setRemainingStartTime(Math.floor(difference / 1000));
  };

  const handleTourneyRemainingTimeToStartTimer = () => {
    const difference = new Date(tourneyStartTime * 1000) - currentLobbyTime;
    setRemainingStartTime(Math.floor(difference / 1000));
  };

  const getTimerValueBasedOnTourneyStage = (currentTourneyStatus) => {
    switch (currentTourneyStatus) {
      case TOURNEY_STATUS_LIVE:
        if (remainingStartTime >= 0) {
          if (!lateRegEnded && lateRegEndTime > 0 && !inTheMoney) {
            return (
              <CountdownTimer
                startTime={selectedTourneyDetails?.lateRegEndTime * 1000}
                isHours
                isMinutes
                isSeconds
              />
            );
          }

          return selectedTourneyDetails.tourneyStartTime ? (
            <RunningSinceTimer
              startTimestamp={Number(
                selectedTourneyDetails.tourneyStartTime * 1000
              )}
            />
          ) : (
            '-'
          );
        } else {
          return '00:00';
        }
      case TOURNEY_ANNOUNCED:
      case TOURNEY_REGISTRATION_STARTED:
      case TOURNEY_REGISTRATION_ENDED:
        return (
          <CountdownTimer
            startTime={selectedTourneyDetails?.tourneyStartTime * 1000}
            isHours
            isMinutes
            isSeconds
          />
        );

      case TOURNEY_STATUS_WON:
      case TOURNEY_STATUS_COMPLETED:
      case TOURNEY_STATUS_MISSED:
        return 'Finished';
      case TOURNEY_STATUS_CANCELLED:
        return 'Cancelled';
      default:
        return '';
    }
  };

  const showNotificationIcon = (currentTourneyStatus) => {
    switch (currentTourneyStatus) {
      case TOURNEY_STATUS_CANCELLED:
        return false;
      case TOURNEY_OFFLINE_PAUSED:
        return false;
      case TOURNEY_STATUS_MISSED:
        return false;
      case TOURNEY_STATUS_WON:
        return false;
      case TOURNEY_STATUS_COMPLETED:
        return false;
    }
  };

  const checkTourneyGameTableIsAvailable = () => {
    return tourneyActiveGames;
  };

  const handleAddCash = () => {
    console.log('clicked: handleAddCash ');
    addCashNavigation();
  };

  const handleJoinBack = () => {
    navigate('/game');
  };

  console.log('tourderdefinition: ', selectedTourneyDetails);

  const SolidButton = ({
    handleButtonClick,
    buttonLable,
    disabled = false,
    isGreenButton = false
  }) => {
    return (
      <div
        className={`text-primary flex flex-1 items-center justify-center py-2 text-base font-bold ${
          selectedTourneyDetails?.isAlreadyRegisteredTourney && !isGreenButton
            ? 'from-error-primary to-error-secondary border-error-primary border bg-linear-to-b'
            : 'from-success to-button-2 bg-linear-to-b from-30%'
        } my-3 rounded`}
        onClick={() => {
          !disabled && handleButtonClick();
        }}
      >
        {buttonLable}
      </div>
    );
  };

  const getCurrentAvailableFlights = () => {
    if (selectedTourneyDetails?.isFlightParentTourney) {
      return selectedTourneyDetails?.currentAvailableFlights;
    } else {
      switch (selectedTourneyDetails?.tourneyStatus) {
        case TOURNEY_ANNOUNCED:
        case TOURNEY_REGISTRATION_STARTED:
        case TOURNEY_REGISTRATION_ENDED:
          return selectedTourneyDetails?.currentAvailableFlights - 1;
        case TOURNEY_STATUS_LIVE:
        case TOURNEY_STATUS_MISSED:
          if (selectedTourneyDetails?.inTheMoney) {
            return selectedTourneyDetails?.currentAvailableFlights;
          } else if (
            selectedTourneyDetails?.lateRegistrationAllowed &&
            selectedTourneyDetails?.lateRegistrationStatus !== 'FINISHED'
          ) {
            return selectedTourneyDetails?.currentAvailableFlights - 1;
          } else {
            return selectedTourneyDetails?.currentAvailableFlights;
          }
        default:
          return selectedTourneyDetails?.currentAvailableFlights;
      }
    }
  };

  const LineButton = ({
    handleClick,
    buttonLable,
    showSimilarBadge = false
  }) => {
    return (
      <div
        className="text-success border-success relative my-3 flex w-1/3 flex-1 items-center justify-center gap-1 rounded border py-2 text-sm font-bold"
        onClick={() => {
          handleClick();
        }}
      >
        <ChainIcon />
        <div>{buttonLable}</div>

        {showSimilarBadge &&
          selectedTourneyDetails?.similarFlights?.length > 0 &&
          getCurrentAvailableFlights() > 0 && (
            <TourneyDetailsSimilarFlightsBadge
              similarFlights={getCurrentAvailableFlights()}
              threshold={selectedTourneyDetails?.flightXThreshold}
            />
          )}

        {showSimilarBadge &&
          selectedTourneyDetails?.childTourneys?.length > 0 && (
            <TourneyDetailsSimilarFlightsBadge
              similarFlights={selectedTourneyDetails?.childTourneys?.length}
              satellites={true}
            />
          )}
      </div>
    );
  };

  const getTourneyInfoFooterBasedOnTourneyStats = (tourneyDetailsObj) => {
    const {
      tourneyStatus,
      tourneyPlayerStatus,
      isAlreadyRegisteredTourney,
      reminder,
      tourneyRake,
      buyIn,
      registeredPlayerCount,
      tournamentType,
      maxPlayers,
      hideRegistrationCTAButtons,
      inTheMoney,
      inTheBubble,
      bustedOut
    } = tourneyDetailsObj;
    switch (tourneyStatus) {
      case TOURNEY_ANNOUNCED:
        // if (tournamentType === TOURNEY_TYPES.SIT_AND_GO) {
        return null;
      // }
      case TOURNEY_REGISTRATION_STARTED:
        if (
          (!tourneyDetailsObj.isAlreadyRegisteredTourney &&
            tourneyDetailsObj.isFlightParentTourney) ||
          registeredPlayerCount == maxPlayers
          // (registeredPlayerCount == maxPlayers &&
          //   !tourneyDetailsObj.isAlreadyRegisteredTourney)
        ) {
          //NOTE: If player is not registered and it is a flight parent tourney then we are not showing any CTA buttons.
          //NOTE: IF registeredPlayerCount reaches equal to maxPlayers
          return;
        }
        if (tourneyDetailsObj.isAlreadyRegisteredTourney) {
          return (
            <div className="flex-1">
              {tourneyDetailsObj.isAlreadyRegisteredTourney &&
              !selectedTourneyDetails.isFlightParentTourney ? (
                <SolidButton
                  buttonLable={'De-register'}
                  handleButtonClick={() => {
                    tourneyDetails?.openRegPopup(true);
                  }}
                />
              ) : tourneyDetailsObj.isAlreadyRegisteredTourney &&
                tourneyDetailsObj.isFlightParentTourney ? (
                <SolidButton
                  buttonLable={'Registered'}
                  handleButtonClick={() => {}}
                  disabled
                />
              ) : checkUserHasTicket(tourneyDetailsObj.tourneyId) ? (
                tourneyDetailsObj.tournamentType === TOURNEY_TYPES.TICKET ||
                checkUserHasTicket(tourneyDetailsObj.tourneyId) ? (
                  <SolidButton
                    buttonLable={'Ticket'}
                    handleButtonClick={() => {
                      tourneyDetails?.openRegPopup(true);
                    }}
                  />
                ) : (
                  <SolidButton
                    buttonLable={'Register'}
                    handleButtonClick={() => {
                      tourneyDetails?.openRegPopup(true);
                    }}
                  />
                )
              ) : null}
            </div>
          );
          // } else if(registeredPlayerCount == maxPlayers) {
          //   return;
        } else if (
          registeredPlayerCount < maxPlayers &&
          !hideRegistrationCTAButtons
        ) {
          if (
            user?.balance?.totalBalance < getTourneyBuyIn() &&
            !checkUserHasTicket(tourneyDetailsObj.tourneyId)
          ) {
            return (
              <SolidButton
                buttonLable={'Add Cash'}
                handleButtonClick={() => {
                  handleAddCash();
                }}
              />
            );
          }
          return (
            <div className="flex-1">
              {tourneyDetailsObj.isAlreadyRegisteredTourney &&
              !tourneyDetailsObj.isFlightParentTourney ? (
                <SolidButton
                  buttonLable={'De-register'}
                  handleButtonClick={() => {
                    tourneyDetails?.openRegPopup(true);
                  }}
                />
              ) : checkUserHasTicket(tourneyDetailsObj.tourneyId) ? (
                <SolidButton
                  buttonLable={'Ticket'}
                  handleButtonClick={() => {
                    tourneyDetails?.openRegPopup(true);
                  }}
                />
              ) : (
                <SolidButton
                  buttonLable={
                    tourneyDetailsObj.tournamentType === TOURNEY_TYPES.TICKET
                      ? 'No Ticket'
                      : 'Register'
                  }
                  handleButtonClick={() => {
                    tourneyDetailsObj.tournamentType === TOURNEY_TYPES.TICKET
                      ? console.log('do nothing') // do nothing
                      : tourneyDetails?.openRegPopup(true); // handleregister method
                  }}
                />
              )}
            </div>
          );
        }
      case TOURNEY_STATUS_LIVE:
        const {
          isAlreadyRegisteredTourney,
          lateRegistrationAllowed,
          lateRegistrationStatus
        } = tourneyDetailsObj;
        if (isAlreadyRegisteredTourney && checkTourneyGameTableIsAvailable()) {
          return (
            <SolidButton
              buttonLable={'Join Back'}
              // buttonLable={"Go To Table"}
              handleButtonClick={() => {
                handleJoinBack();
              }}
              isGreenButton
            />
          );
        } else if (inTheMoney || inTheBubble) {
          return;
        } else if (
          !isAlreadyRegisteredTourney &&
          lateRegistrationAllowed &&
          lateRegistrationStatus !== 'FINISHED'
        ) {
          if (
            user?.balance?.totalBalance < getTourneyBuyIn() &&
            !checkUserHasTicket(tourneyDetailsObj.tourneyId)
          ) {
            return (
              <SolidButton
                buttonLable={'Add Cash'}
                handleButtonClick={() => {
                  handleAddCash();
                }}
              />
            );
          } else if (checkUserHasTicket(tourneyDetailsObj.tourneyId)) {
            return (
              <SolidButton
                buttonLable={'Ticket'}
                handleButtonClick={() => {}}
              />
            );
          }
          return (
            <SolidButton
              // buttonLable={"Register"}
              buttonLable={'Late Register'}
              handleButtonClick={() => {
                tourneyDetails?.openRegPopup(true);
              }}
            />
          );
        } else if (tourneyPlayerStatus === TOURNEY_PLAYER_STATUS_RE_ENTRY) {
          return (
            <Drawer>
              <DrawerTrigger className="flex-1">
                <SolidButton buttonLable={'Re-Entry'} />
              </DrawerTrigger>
              <DrawerContent>
                <DrawerHeader>
                  <DrawerTitle className="text-primary mb-2 text-center text-base font-bold">
                    Are You Sure
                  </DrawerTitle>
                  <DrawerDescription className="text-secondary text-center text-sm font-medium">
                    <span>Do you want to re-enter the tournament</span>
                    <span className="pl-1 font-bold">
                      {selectedTourneyDetails?.tourneyName} ?
                    </span>
                  </DrawerDescription>
                </DrawerHeader>
                <DrawerFooter className="grid grid-cols-2 gap-2">
                  <DrawerClose>
                    <Button className="rounded-500 bg-error-secondary w-full font-bold text-white">
                      No
                    </Button>
                  </DrawerClose>
                  <DrawerClose>
                    <Button
                      onClick={() => handleReEntryTourney()}
                      className="rounded-500 bg-success w-full font-bold text-white"
                    >
                      Yes
                    </Button>
                  </DrawerClose>
                </DrawerFooter>
              </DrawerContent>
            </Drawer>
          );
        }
        return;
      default:
        return null;
    }
  };

  return (
    <div
      className={'font-title text-primary bg-background relative min-h-screen'}
    >
      <div
        className={`border-b-dark sticky top-0 right-0 left-0 z-10 border-b`}
      >
        <TourneyDetailsHeader
          title={selectedTourneyDetails?.tourneyName || ''}
          // showNotification={selectedTourneyDetails?.isAlreadyRegisteredTourney}
          showNotification={
            tourneyStartTime * 1000 < new Date().getTime() ? false : true
          }
          reminder={
            tourneyStartTime * 1000 < new Date().getTime()
              ? ' '
              : selectedTourneyDetails?.reminder
          }
          handleNotification={
            tourneyStartTime * 1000 < new Date().getTime()
              ? ' '
              : handleNotification
          }
        />
        {/* tabbaar section */}

        {selectedTourneyDetails?.tourneyStartTime &&
          activeTab !== 'overview' && (
            <div
              className={`from-foreground via-accent to-foreground flex h-8 items-center justify-center bg-linear-to-r`}
            >
              {(() => {
                const { label, color } =
                  getTourneyTimerLabelAndColor(tourneyStatus);
                return (
                  <span
                    className={`text-primary flex items-center gap-1 text-xs font-medium`}
                  >
                    {label && <span className={color}>{label}</span>}
                    {getTimerValueBasedOnTourneyStage(tourneyStatus)}
                  </span>
                );
              })()}
            </div>
          )}

        {/* <div
          className={`px-3 flex overflow-x-scroll whitespace-nowrap bg-foreground`}
          ref={(el) => {
            if (el) {
              const activeTabIndex = TABS.findIndex(
                (tab) => tab.key === activeTab
              );
              const activeTabElement = el.children[activeTabIndex];
              if (activeTabElement) {
                activeTabElement.scrollIntoView({
                  behavior: "smooth",
                  inline: "center",
                });
              }
            }
          }}
        >
          {TABS.map((tab, idx) => (
            <div
              key={idx}
              className={` py-3 px-4 text-sm border-b-2  ${
                tab.key === activeTab
                  ? "text-gold-primary font-medium border-b-gold-primary"
                  : "border-b-transparent font-normal text-secondary"
              }`}
              onClick={() => {
                setActiveTab(tab.key);
              }}
            >
              {tab.lable}
            </div>
          ))}
        </div> */}
        <TourneyDetailsTabBar
          tabs={TABS}
          activeTab={activeTab}
          onTabChange={(tab) => {
            setActiveTab(tab.key);
          }}
        />
      </div>

      {selectedTourneyDetails && (
        <>
          <div
            ref={scrollContainerRef}
            className={`overflow-y-auto p-4 pb-24`}
            style={{ height: 'calc(100vh - 6rem)' }}
          >
            {activeTab === 'overview' ? (
              <div>
                {selectedTourneyDetails ? (
                  <TourneyDetailsOverview
                    selectedTourneyDetails={selectedTourneyDetails}
                  />
                ) : (
                  <div />
                )}
                {false && (
                  <div className="fixed right-0 bottom-10 left-0 pb-8">
                    <div className="flex items-center justify-center">
                      <Drawer>
                        <DrawerTrigger>
                          <div className="to-accent p flex items-center rounded-full border border-teal-700 bg-linear-to-r from-teal-800 px-3 py-2">
                            <TreeNodeIcon />
                            <div className="mx-1 text-sm font-medium">
                              Related Series
                            </div>
                            <ChevronRight clr={'#fff'} height={10} width={8} />
                          </div>
                        </DrawerTrigger>

                        <DrawerContent className={`bg-foreground`}>
                          <div className="bg-foreground text-primary overflow-scroll rounded px-3 pt-2 pb-4 text-xs font-medium">
                            <div className="mb-2 flex items-center justify-between">
                              <div className="text-sm">Series Lineup</div>
                              <DrawerClose asChild>
                                <div>
                                  <CloseIcon />
                                </div>
                              </DrawerClose>
                            </div>
                            {[1, 2, 3].map((item, key) => (
                              <div className="from-accent/80 to-accent/35 mb-2 flex items-center justify-between rounded-md bg-linear-to-r p-2">
                                <div className="flex items-center">
                                  <SeriesTicketIcon />
                                  <div className="ml-2">
                                    10 SATELLITES TO THIS FLIGHT
                                  </div>
                                </div>
                                <div className="flex items-center">
                                  <div className="text-success mr-1">
                                    Details
                                  </div>
                                  <ChevronRight clr="#42BE40" />
                                </div>
                              </div>
                            ))}
                          </div>
                        </DrawerContent>
                      </Drawer>
                    </div>
                  </div>
                )}
              </div>
            ) : activeTab === 'entries' ? (
              <TourneyDetailsEntries
                selectedTourneyDetails={selectedTourneyDetails}
                tourneyDetails={tourneyDetails}
                displayName={displayName}
              />
            ) : activeTab === 'prizes' ? (
              <TourneyDetailsPrizes
                selectedTourneyDetails={selectedTourneyDetails}
              />
            ) : activeTab === 'rules' ? (
              <TourneyDetailsRules
                selectedTourneyDetails={selectedTourneyDetails}
              />
            ) : activeTab === 'tables' ? (
              selectedTourneyDetails?.tourneyTablesStatusList?.length > 0 ? (
                <TourneyDetailsTable
                  selectedTourneyDetails={selectedTourneyDetails}
                />
              ) : (
                <div>
                  <div
                    className={`flex h-80 flex-col items-center justify-center`}
                  >
                    <img src={gameAssets.TableEmptyState} />
                    <div className={`text-secondary mt-4 text-sm`}>
                      Table will shown once tourney started
                    </div>
                  </div>
                </div>
              )
            ) : activeTab === 'blindStructure' ? (
              <TourneyDetailsBlindStructure
                selectedTourneyDetails={selectedTourneyDetails}
                blindStructure={selectedTourneyDetails?.blindStructure}
              />
            ) : activeTab === 'rebuyInfo' ? (
              <TourneyDetailsRebuyInfo
                selectedTourneyDetails={selectedTourneyDetails}
              />
            ) : activeTab === 'flights' ? (
              <TourneyDetailsFlights
                selectedTourneyDetails={selectedTourneyDetails}
                tourneyNav={tourneyDetails}
              />
            ) : activeTab === 'prizeStructure' ? (
              <TourneyDetailsPrizeStructure
                selectedTourneyDetails={selectedTourneyDetails}
              />
            ) : activeTab === 'bountyInfo' ? (
              <TourneyDetailsBountyInfo />
            ) : activeTab === 'targetTourney' ? (
              <TourneyDetailsTargetTourney
                selectedTourneyDetails={selectedTourneyDetails}
              />
            ) : (
              <div />
            )}
          </div>

          <ScrollToTopButton
            onClick={scrollToTop}
            visible={showScrollToTop}
            classNew="fixed bottom-20 right-10 w-10 h-10 bg-foreground flex items-center justify-center text-white p-3 rounded-full shadow-lg z-50"
          />
        </>
      )}

      {/* Footer Part  */}
      <div className="bg-background border-b-dark fixed right-0 bottom-0 left-0 flex items-center gap-2 border-t px-4">
        {(selectedTourneyDetails?.tournamentType ===
          TOURNEY_TYPES.FLIGHT_CHILD ||
          selectedTourneyDetails?.tournamentType ===
            TOURNEY_TYPES.FLIGHT_PARENT) &&
          activeTab !== 'flights' && (
            <LineButton
              buttonLable={'Series'}
              handleClick={() => {
                setActiveTab('flights');
              }}
              showSimilarBadge
            />
          )}
        {selectedTourneyDetails?.tournamentType === TOURNEY_TYPES.SATELLITE &&
          activeTab !== 'targetTourney' && (
            <LineButton
              buttonLable={'Target Tourney'}
              handleClick={() => {
                setActiveTab('targetTourney');
              }}
            />
          )}
        {getTourneyInfoFooterBasedOnTourneyStats(selectedTourneyDetails)}

        <Drawer open={tourneyDetails?.showTourneyRegisterConfirmationPopup}>
          <DrawerContent className={'bg-foreground'}>
            <div className="bg-foreground text-primary overflow-scroll rounded pt-2 pb-4 text-xs font-medium">
              <div className="text-gold-primary border-b-dark border-b pb-2 text-center text-sm font-medium">
                Info
              </div>
              <div className="p-4">
                <div className="text-primary text-center text-sm font-medium">
                  {`Do you want to ${
                    selectedTourneyDetails?.isAlreadyRegisteredTourney
                      ? 'deregister from '
                      : 'register for'
                  }  ${selectedTourneyDetails?.tourneyName} ?`}
                </div>
                <div className="text-secondary font-regular mt-2 text-center text-xs">
                  {selectedTourneyDetails?.tournamentType ===
                    TOURNEY_TYPES.TICKET ||
                  checkUserHasTicket(selectedTourneyDetails?.tourneyId)
                    ? ''
                    : `Amount : ₹${getTourneyBuyIn()}`}
                </div>
                <div className="mt-4 flex items-center justify-center">
                  <div className="text-success border-success mr-3 w-1/2 rounded border py-2 text-center text-sm font-bold">
                    <div
                      className="ml-1"
                      onClick={() => {
                        tourneyDetails?.openRegPopup(false);
                      }}
                    >
                      No
                    </div>
                  </div>
                  <div
                    className="text-primary from-success border-success flex w-1/2 items-center justify-center rounded border bg-linear-to-b to-green-700 py-2 text-center text-sm font-bold"
                    onClick={() => {
                      selectedTourneyDetails?.isAlreadyRegisteredTourney
                        ? handleDeregisterTourney()
                        : handleRegisterTourney();
                    }}
                  >
                    <div>Yes</div>
                  </div>
                </div>
              </div>
            </div>
          </DrawerContent>
        </Drawer>
      </div>
    </div>
  );
}

export default TourneyDetails;

/*
const mselectedTourneyDetails = {
  winnersPayoutWithBonus: {
    1: {
      amount: 250,
      bonus: 0,
      ticket: false,
    },
    2: {
      amount: 250,
      bonus: 0,
      ticket: false,
    },
    3: {
      amount: 150,
      bonus: 0,
      ticket: false,
    },
    4: {
      amount: 150,
      bonus: 0,
      ticket: false,
    },
    5: {
      amount: 100,
      bonus: 0,
      ticket: false,
    },
    6: {
      amount: 100,
      bonus: 0,
      ticket: false,
    },
  },
  tourneyId: "gib7f",
  tourneyName: "tourny000001111 pauseeeee",
  blindStructureLevel: 1,
  childBlindStartLevel: 0,
  blindStructureEndLevel: 0,
  consolidationLogic: null,
  flightXThreshold: 0,
  highlighted: false,
  similarFlights: [],
  allFlightsEnded: false,
  tournamentType: "GTD",
  totalPrize: "",
  currentLevel: 0,
  tourneyStatus: "Missed",
  tourneyStartTime: 1751264760,
  tourneyEndTime: 0,
  levelDuration: 60,
  registeredPlayerCount: 10,
  tourneyDescription: null,
  gameDefID: null,
  parentTourney: "",
  parentTourneyName: "NA",
  totalWinners: 6,
  lateRegistrationAllowed: true,
  lateRegistrationStatus: "FINISHED",
  lateRegistrationDuration: 5,
  lateRegisterEntryAmount: 0,
  lateRegisterStartingStack: 0,
  lateRegistrationsCount: 0,
  gameType: "TEXAS_HOLDEM",
  smallBlind: 10,
  bigBlind: 20,
  isRITEnabled: false,
  maxPlayers: 30,
  isStraddleEnabled: false,
  isSNG: false,
  anonymous: false,
  nodeIps: ["65.0.170.58"],
  registrationStartTime: 1751264640,
  registrationEndTime: 1751265060,
  announcementStartDate: 1751264580,
  minPlayers: 2,
  entryFee: 10,
  tourneyRake: 1,
  buyIn: 9,
  cashType: null,
  prizePayoutType: null,
  prizePool: 1000,
  tourneyRules: "sdvfdsv",
  isFeatured: true,
  extraTime: 0,
  totalAddOns: 0,
  addOnAmount: 0,
  totalReBuyIns: 0,
  reBuyInAmount: 0,
  startingChipsCount: 1000,
  playersPerTable: 6,
  reEntry: {
    reEntrySettings: {
      chipsToBeGranted: 1000,
      noOfReentry: 10,
      reEntryBuyIn: 10,
      reentryEntryFee: 11,
      reEntryBountyBuyIn: 0,
      reentryLevel: 10,
      reEntryRake: 1,
    },
  },
  payoutType: "Fixed",
  createdAt: "1751264585029",
  tournamentLobbyType: "Normal",
  blindStructure: [
    {
      bb: 20,
      ante: 0,
      level: 1,
      sb: 10,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 40,
      ante: 0,
      level: 2,
      sb: 20,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 60,
      ante: 0,
      level: 3,
      sb: 30,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 80,
      ante: 0,
      level: 4,
      sb: 40,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 100,
      ante: 0,
      level: 5,
      sb: 50,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 120,
      ante: 0,
      level: 6,
      sb: 60,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 150,
      ante: 0,
      level: 7,
      sb: 75,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 200,
      ante: 20,
      level: 8,
      sb: 100,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 250,
      ante: 25,
      level: 9,
      sb: 125,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 300,
      ante: 30,
      level: 10,
      sb: 150,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 400,
      ante: 40,
      level: 11,
      sb: 200,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 500,
      ante: 50,
      level: 12,
      sb: 250,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 600,
      ante: 60,
      level: 13,
      sb: 300,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 800,
      ante: 80,
      level: 14,
      sb: 400,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 1000,
      ante: 100,
      level: 15,
      sb: 500,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 1200,
      ante: 120,
      level: 16,
      sb: 600,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 1400,
      ante: 140,
      level: 17,
      sb: 700,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 1600,
      ante: 160,
      level: 18,
      sb: 800,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 1800,
      ante: 180,
      level: 19,
      sb: 900,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 2000,
      ante: 200,
      level: 20,
      sb: 1000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 2500,
      ante: 250,
      level: 21,
      sb: 1250,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 2800,
      ante: 280,
      level: 22,
      sb: 1400,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 3000,
      ante: 300,
      level: 23,
      sb: 1500,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 3500,
      ante: 350,
      level: 24,
      sb: 1750,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 4000,
      ante: 400,
      level: 25,
      sb: 2000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 5000,
      ante: 500,
      level: 26,
      sb: 2500,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 6000,
      ante: 600,
      level: 27,
      sb: 3000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 7000,
      ante: 700,
      level: 28,
      sb: 3500,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 8000,
      ante: 800,
      level: 29,
      sb: 4000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 9000,
      ante: 900,
      level: 30,
      sb: 4500,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 10000,
      ante: 1000,
      level: 31,
      sb: 5000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 12000,
      ante: 1200,
      level: 32,
      sb: 6000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 14000,
      ante: 1400,
      level: 33,
      sb: 7000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 16000,
      ante: 1600,
      level: 34,
      sb: 8000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 18000,
      ante: 1800,
      level: 35,
      sb: 9000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 20000,
      ante: 2000,
      level: 36,
      sb: 10000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 25000,
      ante: 2500,
      level: 37,
      sb: 12500,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 30000,
      ante: 3000,
      level: 38,
      sb: 15000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 35000,
      ante: 3500,
      level: 39,
      sb: 17500,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 40000,
      ante: 4000,
      level: 40,
      sb: 20000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 50000,
      ante: 5000,
      level: 41,
      sb: 25000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 60000,
      ante: 6000,
      level: 42,
      sb: 30000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 70000,
      ante: 7000,
      level: 43,
      sb: 35000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 80000,
      ante: 8000,
      level: 44,
      sb: 40000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 100000,
      ante: 10000,
      level: 45,
      sb: 50000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 120000,
      ante: 12000,
      level: 46,
      sb: 60000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 150000,
      ante: 15000,
      level: 47,
      sb: 75000,
      levelDuration: 0,
      finalLevel: false,
    },
    {
      bb: 200000,
      ante: 20000,
      level: 48,
      sb: 100000,
      levelDuration: 0,
      finalLevel: false,
    },
  ],
  winTheButton: false,
  breakEven: false,
  dynamicPoolPrize: 0,
  totalTimeForTimerTourney: null,
  rebuyFee: null,
  rebuyLevel: null,
  noOfRebuys: null,
  prizePoolTickets: 0,
  lateRegEnded: true,
  childTourneys: [],
  priorityNode: "65.0.170.58",
  prizePoolType: "Fixed",
  inTheMoney: true,
  totalReEntryCount: 1,
  totalRebuyCount: 0,
  totalAddOnCount: 0,
  displayWinners: 6,
  depositTourneyFlag: false,
  allowedFreeRegistrations: 0,
  allowedTicketRegistrations: 0,
  minAddCashAmount: 0,
  addCashTicketRegistration: true,
  depositorDirectRegistrations: 0,
  depositorTicketRegistrations: 0,
  averageChips: 1000,
  breakInProgress: false,
  breakStartTime: 0,
  breakEndTime: 0,
  lateRegEndTime: 1751265060,
  childTourneyDetails: [],
  tourneyCompleteViaAtInTheMoney: false,
  parentTourneyPrizePool: 0,
  maxRebuyCount: -1,
  pauseFinalTable: true,
  bountyTourney: false,
  bountyBuyIn: 0,
  bountyPool: 0,
  bountyCredit: 0,
  bountyTourneyType: "",
  totalBountyPrizePool: 1000,
  bountyTourneyPrizePool: 0,
  reEntryType: "ReEntry",
  familyName: null,
  tourneyTabs: [],
  tourneyFeatures: {
    winTheButton: false,
    blanketCheck: false,
    pauseFinalTable: false,
    depositTourneyFlag: false,
    depositTourneyFlagA52: false,
    bountyTourney: false,
    dealMaking: false,
    shufflingEnabled: false,
  },
  tourneyIdentifier: "completedTourneys",
  tourneyPlayerStatus: "Missed",
  isAlreadyRegisteredTourney: false,
  isFlightTourney: false,
  isFlightParentTourney: false,
  bustedOut: false,
  activePlayerForTourney: 10,
  reminder: false,
  tourneyEntriesData: [
    {
      playerName: "blitz516464",
      playerChips: 4000,
      gameStartChips: 0,
      isBustedOut: false,
      bustedOutTimeStamp: 0,
      registrationTimeStamp: 0,
      rank: "pause",
      winner: false,
      winningAmount: "offline",
      winningBonusAmount: 0,
      winningDistributed: false,
      isCredited: false,
      ticketAssigned: false,
      bountyAmount: 0,
      noOfKnockedOutPlayers: 0,
      isInBubble: false,
      bubbleBatchIdentifier: 0,
      dealMaking: false,
      isInTheMoney: false,
    },
    {
      playerName: "reaper669494",
      playerChips: 2940,
      gameStartChips: 0,
      isBustedOut: false,
      bustedOutTimeStamp: 0,
      registrationTimeStamp: 0,
      rank: "pause",
      winner: false,
      winningAmount: "offline",
      winningBonusAmount: 0,
      winningDistributed: false,
      isCredited: false,
      ticketAssigned: false,
      bountyAmount: 0,
      noOfKnockedOutPlayers: 0,
      isInBubble: false,
      bubbleBatchIdentifier: 0,
      dealMaking: false,
      isInTheMoney: false,
    },
    {
      playerName: "opal935995",
      playerChips: 1060,
      gameStartChips: 0,
      isBustedOut: false,
      bustedOutTimeStamp: 0,
      registrationTimeStamp: 0,
      rank: "pause",
      winner: false,
      winningAmount: "offline",
      winningBonusAmount: 0,
      winningDistributed: false,
      isCredited: false,
      ticketAssigned: false,
      bountyAmount: 0,
      noOfKnockedOutPlayers: 0,
      isInBubble: false,
      bubbleBatchIdentifier: 0,
      dealMaking: false,
      isInTheMoney: false,
    },
    {
      playerName: "mojo425665",
      playerChips: 1000,
      gameStartChips: 0,
      isBustedOut: false,
      bustedOutTimeStamp: 0,
      registrationTimeStamp: 0,
      rank: "pause",
      winner: false,
      winningAmount: "offline",
      winningBonusAmount: 0,
      winningDistributed: false,
      isCredited: false,
      ticketAssigned: false,
      bountyAmount: 0,
      noOfKnockedOutPlayers: 0,
      isInBubble: false,
      bubbleBatchIdentifier: 0,
      dealMaking: false,
      isInTheMoney: false,
    },
    {
      playerName: "speed300099",
      playerChips: 1000,
      gameStartChips: 0,
      isBustedOut: false,
      bustedOutTimeStamp: 0,
      registrationTimeStamp: 0,
      rank: "pause",
      winner: false,
      winningAmount: "offline",
      winningBonusAmount: 0,
      winningDistributed: false,
      isCredited: false,
      ticketAssigned: false,
      bountyAmount: 0,
      noOfKnockedOutPlayers: 0,
      isInBubble: false,
      bubbleBatchIdentifier: 0,
      dealMaking: false,
      isInTheMoney: false,
    },
    {
      playerName: "zircon879889",
      playerChips: 0,
      gameStartChips: 1000,
      isBustedOut: true,
      bustedOutTimeStamp: 1751264839612,
      registrationTimeStamp: 1751264658648,
      rank: 6,
      winner: true,
      winningAmount: 100,
      winningBonusAmount: 0,
      winningDistributed: true,
      isCredited: true,
      ticketAssigned: false,
      bountyAmount: 0,
      noOfKnockedOutPlayers: 0,
      bubbleType: "FINAL_TABLE",
      isInBubble: true,
      bubbleBatchIdentifier: 1751264825292,
      dealMaking: false,
      isInTheMoney: true,
    },
    {
      playerName: "star12345",
      playerChips: 0,
      gameStartChips: 1000,
      isBustedOut: true,
      bustedOutTimeStamp: 1751264839612,
      registrationTimeStamp: 1751264659657,
      rank: 7,
      winner: false,
      winningAmount: 0,
      winningBonusAmount: 0,
      winningDistributed: false,
      isCredited: true,
      ticketAssigned: false,
      bountyAmount: 0,
      noOfKnockedOutPlayers: 0,
      bubbleType: "FINAL_TABLE",
      isInBubble: true,
      bubbleBatchIdentifier: 1751264825292,
      dealMaking: false,
      isInTheMoney: true,
    },
    {
      playerName: "myst19999",
      playerChips: 0,
      gameStartChips: 990,
      isBustedOut: true,
      bustedOutTimeStamp: 1751264825282,
      registrationTimeStamp: 1751264663041,
      rank: 8,
      winner: false,
      winningAmount: 0,
      winningBonusAmount: 0,
      winningDistributed: false,
      isCredited: true,
      ticketAssigned: false,
      bountyAmount: 0,
      noOfKnockedOutPlayers: 0,
      bubbleType: "None",
      isInBubble: false,
      bubbleBatchIdentifier: 0,
      dealMaking: false,
      isInTheMoney: false,
    },
    {
      playerName: "turbo600000",
      playerChips: 0,
      gameStartChips: 1000,
      isBustedOut: true,
      bustedOutTimeStamp: 1751264818136,
      registrationTimeStamp: 1751264656531,
      rank: 9,
      winner: false,
      winningAmount: 0,
      winningBonusAmount: 0,
      winningDistributed: false,
      isCredited: true,
      ticketAssigned: false,
      bountyAmount: 0,
      noOfKnockedOutPlayers: 0,
      bubbleType: "None",
      isInBubble: false,
      bubbleBatchIdentifier: 0,
      dealMaking: false,
      isInTheMoney: false,
    },
    {
      playerName: "mojo425665#1",
      playerChips: 0,
      gameStartChips: 1000,
      isBustedOut: true,
      bustedOutTimeStamp: 1751264794087,
      registrationTimeStamp: 1751264655499,
      rank: 10,
      winner: false,
      winningAmount: 0,
      winningBonusAmount: 0,
      winningDistributed: false,
      isCredited: true,
      ticketAssigned: false,
      bountyAmount: 0,
      noOfKnockedOutPlayers: 0,
      bubbleType: "None",
      isInBubble: false,
      bubbleBatchIdentifier: 0,
      dealMaking: false,
      isInTheMoney: false,
    },
  ],
};
*/
